import {
	BestLeftArrowSVG,
	BestRightArrowSVG,
	BetterLeftArrowSVG,
	BetterRightArrowSVG,
} from '../assets';

export type ArrowOption = 'best-left' | 'better-left' | 'best-right' | 'better-right' | 'none';

const arrowOptionMap = {
	'best-left': BestLeftArrowSVG,
	'better-left': BetterLeftArrowSVG,
	'best-right': BestRightArrowSVG,
	'better-right': BetterRightArrowSVG,
	none: undefined,
};

interface getArrowIconParams {
	option: ArrowOption;
}
export const getArrowIcon = ({ option }: getArrowIconParams): (() => React.JSX.Element) | (() => React.JSX.Element) | (() => React.JSX.Element) | (() => React.JSX.Element) | undefined => {
	const glyph = arrowOptionMap[option];
	return glyph;
};
